module.exports = __webpack_public_path__ + "img/item_Story_06.691a7ca4.jpeg";